import { CardContainer, HorizontalContainer, VerticalContainer } from "@shared/designSystem/Containers";
import { SystemIcon } from "@shared/designSystem/SystemIcon";
import type { SystemIconType } from "@shared/designSystem/SystemIcon";
import type { IconWeight } from "@phosphor-icons/react";
import { H1Title, H2Title } from "@shared/designSystem/Titles";
import { LeftMenuOption } from "@shared/designSystem/LeftMenuOption";
import { Text } from "@shared/designSystem/Texts";
import designSystemStyles from "@shared/styles/designSystemStyles";

const systemIconTypes: SystemIconType[] = [
    'alert',
    'bank',
    'bell',
    'box',
    'building',
    'calendar',
    'camera',
    'chart',
    'chart2',
    'check',
    'chevron',
    'clock',
    'close',
    'dark_mode',
    'dashboard',
    'delete',
    'download',
    'edit',
    'email',
    'eye',
    'face',
    'finder',
    'help',
    'home',
    'inbox',
    'info',
    'listado',
    'lock',
    'logout',
    'map',
    'megaphone',
    'notes',
    'people',
    'people2',
    'profile',
    'qr',
    'rocket',
    'roster',
    'search',
    'send',
    'settings',
    'ticket',
    'wall',
    'warning-triangle'
];

const systemIconWeights: IconWeight[] = ['thin', 'light', 'regular', 'bold', 'fill', 'duotone'];

const SystemIconShowcaseScreen = () => {
    return (
        <VerticalContainer height="100%" scrollable={true} padding={designSystemStyles.paddingMd}>
            <H1Title text="System Icons Showcase" />
            <CardContainer>
                <H2Title text="All icons (small / medium / large)" />
                <VerticalContainer gap={designSystemStyles.gapSm}>
                    {systemIconTypes.map((type) => (
                        <HorizontalContainer key={type}>
                            <SystemIcon type={type} color={designSystemStyles.colorMainAction} size="small" />
                            <SystemIcon type={type} color={designSystemStyles.colorMainAction} />
                            <SystemIcon type={type} color={designSystemStyles.colorMainAction} size="large" />
                            <Text text={type} />
                        </HorizontalContainer>
                    ))}
                </VerticalContainer>
            </CardContainer>
            <CardContainer>
                <H2Title text="Left menu option (icon fills on hover)" />
                <VerticalContainer gap={designSystemStyles.gapSm} width="350px" alignment="left">
                    <LeftMenuOption label="Colaboradores" icon="people" onClick={() => {}} />
                    <LeftMenuOption label="Notificaciones" icon="bell" onClick={() => {}} />
                    <LeftMenuOption label="Configuración" icon="settings" onClick={() => {}} />
                    <LeftMenuOption label="Reportes (active)" icon="chart2" isActive={true} onClick={() => {}} />
                    <LeftMenuOption label="Banco de Horas (locked)" icon="bank" isLocked={true} onClick={() => {}} />
                </VerticalContainer>
            </CardContainer>
            <CardContainer>
                <H2Title text="Icon weights" />
                <VerticalContainer gap={designSystemStyles.gapSm}>
                    {systemIconWeights.map((weight) => (
                        <HorizontalContainer key={weight}>
                            <SystemIcon type="bell" color={designSystemStyles.colorMainAction} weight={weight} />
                            <SystemIcon type="settings" color={designSystemStyles.colorMainAction} weight={weight} />
                            <SystemIcon type="people2" color={designSystemStyles.colorMainAction} weight={weight} />
                            <SystemIcon type="delete" color={designSystemStyles.colorMainAction} weight={weight} />
                            <Text text={weight} />
                        </HorizontalContainer>
                    ))}
                </VerticalContainer>
            </CardContainer>
        </VerticalContainer>
    );
};

export default SystemIconShowcaseScreen;
